import React, { useState } from 'react';
import Modal from '../../../BaseComponents/Modal';
import Button from '../../../BaseComponents/Button';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { deleteFood } from '../../../../api/food';
import {changeDeleteFoodModalVisibility, setFoodToDelete} from "../../../../store/foodsSlice"
import { toast } from 'react-toastify';

type Props = {
  isOpen: boolean;
};

const DeleteFood = ({ isOpen }: Props) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const { foodToDelete} = useSelector(
    (state: RootState) => state.foods
  );
  const onDeleteClick = async () => {
    setLoading(true);
    try {
      if (foodToDelete) {
        const deleteResponse = await deleteFood(foodToDelete.id as number);
        
        if (deleteResponse.description) {
          toast.error(deleteResponse.description);
          return;
        }
        dispatch(setFoodToDelete(null));
        dispatch(changeDeleteFoodModalVisibility(false));
        toast.success('Food deleted successfully');
      }
      dispatch(setFoodToDelete(null));
      dispatch(changeDeleteFoodModalVisibility(false));
    } catch (error) {
      console.log('error :>> ', error);
      toast.error('Cannot delete food with assigned members');
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={() => {
      dispatch(setFoodToDelete(null));
      dispatch(changeDeleteFoodModalVisibility(false));
    }} width={'420px'}>
      <div className='delete-block-container'>
        <div className='modal-header'>
          <div className='title'>Are you sure you want to delete food?</div>
          <div className='sub-title'>All data will be permanently removed.</div>
        </div>

        <div className='submit-btn-wrapper'>
          <Button
            text='Cancel'
            onClick={() => {
              dispatch(setFoodToDelete(null));
              dispatch(changeDeleteFoodModalVisibility(false));
            }}
            backgroundColor={'#ffffff'}
            color={'#2D334E'}
          />
          <Button text='Delete' onClick={onDeleteClick} isLoading={loading} />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteFood;
